module.exports = "//public.getcloudapp.com/packs/media/images/onboarding/chrome-22a06d54f9355a04b791e13f84f44faf.svg";